import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useLazyReadProductsQuery } from '../service/products';
import { ProductsFilters } from '../service/products.interface';
import { selectInitialFilters } from '../utils/filters';
import { useAppSelector } from '../../../../../store';
import { getShopState } from '../../shops/store/shopSlice';

export const useList = () => {
    const { type } = useParams();
    const { current } = useAppSelector(getShopState);

    const [filters, setFilters] = useState({
        ...selectInitialFilters(type, current.id),
    });

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isFiltersEqual, setIsFiltersEqual] = useState(true);

    const [
        getProducts,
        { data: list = { items: [], total: 0 }, isLoading, isFetching },
    ] = useLazyReadProductsQuery();

    useEffect(() => {
        if (filters) {
            setIsFiltersEqual(
                JSON.stringify(filters) ===
                    JSON.stringify(selectInitialFilters(type, current.id))
            );
        }
    }, [filters]);

    useEffect(() => {
        setFilters({
            ...selectInitialFilters(type, current.id),
        });
    }, [type, current.id]);

    useEffect(() => {
        if (filters) {
            getProducts(filters, true);
        }
    }, [filters, current.id]);

    const rowSelection = {
        selectedRowKeys: selectedRowKeys.map(item => item.id),
        onChange: (_, record) => setSelectedRowKeys(record),
        getCheckboxProps: record => ({
            id: record.id,
        }),
    };

    const isProductsActionsVisible = (length = 0) => {
        if (length >= 2) {
            return true;
        }
    };

    const updateFilters = (update: ProductsFilters) => {
        if (update) {
            setFilters({
                ...filters,
                ...update,
            });
        } else {
            setFilters(null);
        }
    };

    const pagination = (total: number) => {
        const pageSizeOptions = (total: number) => {
            const calculateTotal = (size: number) => {
                return Math.floor(total / size);
            };

            return [
                calculateTotal(100),
                calculateTotal(10),
                calculateTotal(4),
                calculateTotal(2),
                total,
            ].filter(size => size > 0);
        };

        return {
            defaultCurrent: filters.page,
            current: filters.page,
            showTitle: true,
            defaultPageSize: filters.limit,
            pageSizeOptions: pageSizeOptions(total),
            onChange: (page: number, pageSize: number) => {
                updateFilters({
                    offset: (page - 1) * pageSize,
                    limit: pageSize,
                    page: page,
                });
            },
            total: list.total,
            showTotal: (total: number) => `Товаров: ${total}`,
        };
    };

    const loading = isFetching || isLoading;

    const isMultipleActionsAvailable = isProductsActionsVisible(
        selectedRowKeys?.length
    );

    return {
        list,
        updateFilters,
        pagination,
        loading,
        filters,
        rowSelection,
        isMultipleActionsAvailable,
        isFiltersEqual,
        setSelectedRowKeys,
    };
};
